"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSiteUrlFromHeaders = void 0;
var headers_1 = require("next/headers");
function getSiteUrlFromHeaders(_a) {
    var baseURL = _a.baseURL;
    var h = (0, headers_1.headers)();
    var host = h.get('host');
    var proto = h.get('x-forwarded-proto') || 'https';
    if (!host) {
        return baseURL;
    }
    return "".concat(proto, "://").concat(host);
}
exports.getSiteUrlFromHeaders = getSiteUrlFromHeaders;
